module.exports = __webpack_public_path__ + "img/asset_stSOL.4617a2a6.svg";